import script from "./SelectAttendees.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectAttendees.vue?vue&type=script&lang=ts&setup=true"

import "./SelectAttendees.vue?vue&type=style&index=0&id=64dfcfda&lang=scss&scoped=true"
import "./SelectAttendees.vue?vue&type=style&index=1&id=64dfcfda&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64dfcfda"]])

export default __exports__